import * as Yup from "yup";

const TCTemaCorporativoGrupoCreateSchema = Yup.object({
    descricao: Yup.string().required({ name: "nome", err: "Campo com preenchimento obrigatório" }),
});


export default TCTemaCorporativoGrupoCreateSchema;